// import { info } from 'node-sass'
import { max } from 'jalali-moment'
import React from 'react'
import { getBoundingClientRect } from '../utils/functions'
import { detectBrowser } from '../utils/useful'

class FixedView extends React.Component {

    state = {
        top: 0,
        left: 0,
        right: 0,
        opacity: 0,
    }


    componentDidMount() {

        // let isRTL = false
        // if (document.body.classList.contains('rtl')) {
        //     isRTL = true
        // }

        // // console.log(isRTL)

        // this.setState({ isRTL })

        setTimeout(() => {
            if (!this.props.nodeRef) {
                // console.log("FORCE")
                this.forceUpdate()
            }
            this.checkRTL()
        }, 50);
    }

    componentWillUnmount() {
        this.hideView()


    }

    checkRTL = () => {
        let isRTL = false
        if (document.body.classList.contains('rtl')) {
            isRTL = true
        }

        // console.log(isRTL)

        this.setState({ isRTL })

    }

    open = (cb) => {
        this.showView(cb)
    }

    showView = (cb) => {

        setTimeout(() => {

            this.getBounding()



            // this.interval = setInterval(() => {
            //     this.getBounding()

            // }, 40);

            // console.log(this.props.nodeRef)

            setTimeout(() => {

                let options = {
                    // root: this.props.nodeRef,
                    rootMargin: '0px',
                    threshold: 0
                }

                // if (!this.observer) {
                this.observer = new IntersectionObserver(this.callback, options);

                this.observer.observe(this.props.nodeRef);



                window.addEventListener('mouseup', this.checkHide, true)
                window.addEventListener('scroll', this.getBounding, true);
                // }
            }, 20);

        }, 10);
        if (cb) {
            cb()
        }

    }

    callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                this.hideView()
            }
        })
    }


    checkHide = (e) => {
        // console.log('hiiideee')
        if (e && this.view && !this.view.contains(e.target)) {
            this.hideView()
        }

    }



    hideView = () => {
        // console.log("hideView")
        // return
        if (this.observer) {
            this.observer.disconnect()
        }
        clearInterval(this.interval)
        window.removeEventListener('mouseup', this.hideView)
        window.removeEventListener('scroll', this.getBounding, true);



        // console.log("this.state.isOpen", this.state.isOpen)
        if (this.props.onHide && this.state.isOpen == true) {
            // console.log("ON HIDEE")
            this.props.onHide()
        }
        this.setState({ opacity: 0 }, () => {
            // setTimeout(() => {
            this.setState({ isOpen: false })
            // }, 500);
        })
        // console.log("this.state.isOpen", this.state.isOpen)

    }

    getBounding = () => {
        // return
        if (this.props.nodeRef && this.view) {

            let topOffset = this.props.topOffset ?? 35
            let bottomOffset = this.props.bottomOffset ?? 0
            let rect = getBoundingClientRect(this.props.nodeRef)
            let indicatorBound = getBoundingClientRect(this.positionIndicator)


            let windowTop = 0



            let spaceFromBottom = window.innerHeight - rect.bottom - windowTop - topOffset
            this.setState({ width: rect.width })

            let spaceFromTop = rect.top + windowTop



            let top = rect.bottom //- indicatorBound.top

            let left = rect.left //- indicatorBound.left
            let maxHeight = this.props.maxHeight ?? 300
            let optimized = false
            // console.log("left",left)

            if (this.content) {
                let contentBound = getBoundingClientRect(this.content)
                maxHeight = contentBound.height
                optimized = true
            }

            if (spaceFromBottom < maxHeight) {
                if (spaceFromBottom < spaceFromTop) {

                    maxHeight = spaceFromTop > maxHeight ? maxHeight : (spaceFromTop - 10)
                    top = top - bottomOffset - maxHeight - 8

                } else {

                    top = top + topOffset
                    maxHeight = spaceFromBottom - 10

                }
            } else {
                top = top + topOffset
            }


            if (this.content) {

                let contentViewBound = getBoundingClientRect(this.content)
                if (this.state.isRTL) {
                    // left = left + contentViewBound.width 
                    left = left - (contentViewBound.width ?? 0) + rect.width
                }

                if (!this.props.rightAlign && this.state.isRTL) {

                    left = left + ((contentViewBound.width ?? 0) * 2) - (rect.width / 2)

                }



            } else {
                optimized = false
            }
            // if ((this.props.rightAlign) && this.content) {

            //     let viewBound = getBoundingClientRect(this.content)
            //     left = left - viewBound.width + 30 + (this.props.xOffset ?? 0)

            // } else if (this.state.isRTL) {

            //     console.log("c", this.content)

            //     let viewBound = getBoundingClientRect(this.content)
            //     console.log(viewBound)
            //     left = left - (viewBound.widt ?? 0) + rect.width
            //     console.log("LEFTTT", left)
            // } else {
            //     left = left - 10 - (this.props.xOffset ?? 0)
            // }

            left = left - (this.props.xOffset ?? 0)


            // console.log("c2", this.content)


            // console.log(top, left,this.content)

            this.setState({ top: top, left: left, maxHeight }, () => {

                if (!this.state.isOpen) {
                    this.setState({ isOpen: true }, () => {
                        this.setState({ opacity: 1 }, () => {

                            if (!optimized) {
                                this.getBounding()
                            }
                        })
                    })
                }

            })
        }
    }



    render() {
        return (
            <div className='' style={{}}>
                <div ref={el => this.positionIndicator = el} className="fix-position-indicator">
                </div>

                <div ref={el => this.view = el} className="fixedView" style={{ width: this.props.width ?? this.state.width, top: this.state.top, left: this.state.left, position: 'fixed', pointerEvents: 'none', transition: 'opacity 0.3s', opacity: this.state.opacity, zIndex: this.props.zIndex ?? 1, maxWidth: this.props.maxWidth, minWidth: this.props.minWidth }}>

                    {this.state.isOpen && (
                        <>
                            {this.props.showFocus && (
                                <div onClick={() => this.hideView()} style={{ pointerEvents: 'all', backgroundColor: '#00051050', height: '100%', top: 0, left: 0, position: 'fixed' }}>
                                </div>
                            )}

                            <div ref={el => this.content = el} onClick={(e) => e.stopPropagation()} style={{ pointerEvents: 'all', }}>
                                {this.props.children}
                            </div>


                        </>
                    )}

                </div>
            </div>
        )
    }
}

export default FixedView;